// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_attributes.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.AppAttributeServiceSearchRequest
 */
export interface AppAttributeServiceSearchRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 2
     */
    query: string;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAttributeServiceSearchResponse
 */
export interface AppAttributeServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppPotentialUserProfileAttribute items = 1
     */
    items: AppPotentialUserProfileAttribute[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppPotentialUserProfileAttribute
 */
export interface AppPotentialUserProfileAttribute {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string attribute_name = 7
     */
    attributeName: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppAttributeServiceSearchRequest$Type extends MessageType<AppAttributeServiceSearchRequest> {
    constructor() {
        super("c1.api.app.v1.AppAttributeServiceSearchRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<AppAttributeServiceSearchRequest>): AppAttributeServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.query = "";
        message.pageToken = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<AppAttributeServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAttributeServiceSearchRequest): AppAttributeServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAttributeServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAttributeServiceSearchRequest
 */
export const AppAttributeServiceSearchRequest = new AppAttributeServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAttributeServiceSearchResponse$Type extends MessageType<AppAttributeServiceSearchResponse> {
    constructor() {
        super("c1.api.app.v1.AppAttributeServiceSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppPotentialUserProfileAttribute },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppAttributeServiceSearchResponse>): AppAttributeServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppAttributeServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAttributeServiceSearchResponse): AppAttributeServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppPotentialUserProfileAttribute items */ 1:
                    message.items.push(AppPotentialUserProfileAttribute.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAttributeServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppPotentialUserProfileAttribute items = 1; */
        for (let i = 0; i < message.items.length; i++)
            AppPotentialUserProfileAttribute.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAttributeServiceSearchResponse
 */
export const AppAttributeServiceSearchResponse = new AppAttributeServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppPotentialUserProfileAttribute$Type extends MessageType<AppPotentialUserProfileAttribute> {
    constructor() {
        super("c1.api.app.v1.AppPotentialUserProfileAttribute", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "attribute_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppPotentialUserProfileAttribute>): AppPotentialUserProfileAttribute {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.appId = "";
        message.id = "";
        message.attributeName = "";
        if (value !== undefined)
            reflectionMergePartial<AppPotentialUserProfileAttribute>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppPotentialUserProfileAttribute): AppPotentialUserProfileAttribute {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string attribute_name */ 7:
                    message.attributeName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppPotentialUserProfileAttribute, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string attribute_name = 7; */
        if (message.attributeName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.attributeName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppPotentialUserProfileAttribute
 */
export const AppPotentialUserProfileAttribute = new AppPotentialUserProfileAttribute$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppAttributeSearchService
 */
export const AppAttributeSearchService = new ServiceType("c1.api.app.v1.AppAttributeSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AppAttributeServiceSearchRequest, O: AppAttributeServiceSearchResponse }
]);
